export default __webpack_public_path__ + "static/stackingrings-c844009fa457d607901d1e4737db699a.png";